import CryptoJS from 'crypto-js';
import { IStripeEncryptProps, IUserData } from 'shared/interface';
import { Languages } from 'shared/util/localization';

let token = '';
export const KEY = process.env.REACT_APP_AUTH_ENCRYPT_KEY || '';

/**
 * function to get user data
 */
const getUserData = (): IUserData => {
	try {
		const data = localStorage.userInfo;
		if (data) {
			const bytes = CryptoJS.AES.decrypt(data.toString(), KEY);
			const decryptedData: IUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
			if (!decryptedData) {
				return {} as IUserData;
			}
			return decryptedData;
		} else {
			return {} as IUserData;
		}
	} catch (error) {
		return {} as IUserData;
	}
};

export const getDeviceId = () => {
	const uuid = localStorage.getItem('deviceId');
	if (uuid && uuid !== '') {
		return uuid;
	} else {
		const uuid = crypto.randomUUID();
		localStorage.setItem('deviceId', uuid);
		return uuid;
	}
};

/**
 * function to set user authentication data
 */
const setAuthData = (data: string): void => {
	token = data;
	const cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), KEY);
	localStorage.setItem('authInfo', cipherText.toString());
};

/**
 * function to set user detail
 */
const setUserData = (data: IUserData): void => {
	const cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), KEY);
	localStorage.setItem('userInfo', cipherText.toString());
};

const getUserLanguage = (): string => {
	const userLang = navigator.language;
	if (userLang.includes(Languages.DE)) {
		return Languages.DE;
	}
	return Languages.EN;
};

/**
 * function to get user access token
 */
const getAccessToken = (): boolean | string => {
	if (token && token !== '') {
		return token;
	}
	try {
		const data = localStorage.authInfo;
		if (data) {
			const bytes = CryptoJS.AES.decrypt(data.toString(), KEY);
			const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
			token = decryptedData ? decryptedData : false;
			return token;
		} else {
			return false;
		}
	} catch (e) {
		return false;
	}
};

/**
 * function to remove user authentication data
 */

const removeAuthData = (): void => {
	localStorage.removeItem('authInfo');
	localStorage.removeItem('userInfo');
	token = '';
};

const logout = () => {
	AuthService.removeAuthData();
};

const encryptStripeClientData = (data: IStripeEncryptProps, encryptionKey = KEY) => {
	const cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey);
	const base64CipherText = cipherText.toString();

	const base64UrlCipherText = base64CipherText.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

	return base64UrlCipherText;
};

export const decryptAES = (encryptedData: string, encryptionKey = KEY): any => {
	const base64CipherText = encryptedData.replace(/-/g, '+').replace(/_/g, '/');
	const paddedCipherText = base64CipherText.padEnd(
		base64CipherText.length + ((4 - (base64CipherText.length % 4)) % 4),
		'='
	);

	const bytes = CryptoJS.AES.decrypt(paddedCipherText, encryptionKey);
	const decrypted = bytes.toString(CryptoJS.enc.Utf8);

	return JSON.parse(decrypted);
};

const AuthService = {
	getUserLanguage: getUserLanguage,
	getAccessToken: getAccessToken,
	getUserData: getUserData,
	setAuthData: setAuthData,
	setUserData: setUserData,
	removeAuthData: removeAuthData,
	logout: logout,
	encryptStripeClientData: encryptStripeClientData
};
export default AuthService;
